<template>
  <div>
    <v-container>
        <v-card>        
            <v-card-text>
                <v-row>
                    <v-col cols="3" class="yellow lighten-4 font-weight-bold">Jadwal</v-col>              
                    <v-col cols="9" >
                        <p>{{ jadwal }}</p>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'JadwalView',
  props: {
      jadwal: {
          type: String,
          default: ""
      }
  }
}
</script>